(()=>{const $=(s,c=document)=>c.querySelector(s),$$=(s,c=document)=>Array.from(c.querySelectorAll(s));const header=$('.site-header');const onScroll=()=>{if(header)header.classList.toggle('is-scrolled',scrollY>20);$$('.reveal,.reveal-item').forEach((el,i)=>{const r=el.getBoundingClientRect();if(r.top<innerHeight*.88){el.style.transitionDelay=(i%6)*40+'ms';el.classList.add('is-visible')}})};addEventListener('scroll',onScroll,{passive:true});addEventListener('load',onScroll);onScroll();const open=(sel)=>$(sel)?.classList.add('is-open');const close=(sel)=>$(sel)?.classList.remove('is-open');$$('.js-menu-open').forEach(b=>b.onclick=()=>open('.mobile-menu'));$$('.js-menu-close').forEach(b=>b.onclick=()=>close('.mobile-menu'));$$('.js-search-open').forEach(b=>b.onclick=()=>open('.search-overlay'));$$('.js-search-close').forEach(b=>b.onclick=()=>close('.search-overlay'));$$('.js-cart-open').forEach(b=>b.onclick=()=>open('.cart-drawer'));$$('.js-cart-close,.drawer-overlay').forEach(b=>b.onclick=()=>close('.cart-drawer'));$$('.faq-q,.accordion__button').forEach(b=>b.addEventListener('click',()=>b.closest('.faq-item,.accordion__item')?.classList.toggle('is-open')));function countdown(){const els=$$('.js-ad-countdown');if(!els.length)return;const now=new Date();let target=new Date(now);target.setHours(6,0,0,0);if(now>=target)target.setDate(target.getDate()+1);let diff=Math.max(0,target-now);let h=String(Math.floor(diff/36e5)).padStart(2,'0');let m=String(Math.floor(diff%36e5/6e4)).padStart(2,'0');let s=String(Math.floor(diff%6e4/1e3)).padStart(2,'0');els.forEach(e=>e.textContent=`${h}:${m}:${s}`)}countdown();setInterval(countdown,1000);$$('.quick-add-form,.pdp-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const btn=form.querySelector('button[type="submit"]');const old=btn?.textContent;if(btn)btn.textContent='Añadiendo...';try{const fd=new FormData(form);await fetch(form.action,{method:'POST',body:fd,headers:{'Accept':'application/json'}});if(btn)btn.textContent='Añadido';setTimeout(()=>{if(btn)btn.textContent=old},900);open('.cart-drawer');refreshCart()}catch(err){form.submit()}}));async function refreshCart(){try{const cart=await fetch('/cart.js').then(r=>r.json());$$('.js-cart-count').forEach(e=>e.textContent=cart.item_count);const wrap=$('.js-drawer-items');if(wrap){wrap.innerHTML=cart.items.map(item=>`<div class="drawer-item"><img src="${item.image||''}" alt=""><div><b>${item.product_title}</b><p class="muted">${item.variant_title||''}</p><div class="qty"><button data-line="${item.key}" data-qty="${item.quantity-1}">−</button><input value="${item.quantity}" readonly><button data-line="${item.key}" data-qty="${item.quantity+1}">+</button></div></div><strong>${formatMoney(item.final_line_price)}</strong></div>`).join('')||'<p>Tu carrito está vacío.</p>'}$$('.js-drawer-total').forEach(e=>e.textContent=formatMoney(cart.total_price))}catch(e){}}function formatMoney(cents){return (cents/100).toLocaleString('es-ES',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'})}document.addEventListener('click',async e=>{const q=e.target.closest('.qty button[data-line]');if(q){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:q.dataset.line,quantity:Number(q.dataset.qty)})});refreshCart();}});$$('.bundle-option').forEach(el=>el.onclick=()=>{$$('.bundle-option',el.closest('.bundle-box')).forEach(x=>x.classList.remove('is-selected'));el.classList.add('is-selected');const qty=el.dataset.qty;const input=$('[name="quantity"]',el.closest('form')||document);if(input)input.value=qty;});document.addEventListener('click',async e=>{const b=e.target.closest('[data-copy-code]');if(!b)return;const code=b.dataset.copyCode||b.textContent.trim();const old=b.textContent;try{await navigator.clipboard.writeText(code);b.textContent='Copiado';setTimeout(()=>b.textContent=old,1200)}catch(err){b.textContent=code;setTimeout(()=>b.textContent=old,1600)}});document.addEventListener('click',e=>{const a=e.target.closest('a[href="#new-drop-26"],a[href="#new-drop-26"]');if(!a)return;const target=document.getElementById('new-drop-26')||document.getElementById('new-drop-26');if(!target)return;e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});});})();
;(()=>{
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const colorMap={
    'negro':'#111111','black':'#111111','blanco':'#f6f2ea','white':'#f6f2ea','beige':'#d8c2a8','arena':'#d8c2a8','sand':'#d8c2a8','marrón':'#8b5e3c','marron':'#8b5e3c','brown':'#8b5e3c','mocha':'#8b5e3c','gris':'#8a8a8a','gray':'#8a8a8a','grey':'#8a8a8a','azul':'#2f4d68','blue':'#2f4d68','rosa':'#d8a0ad','pink':'#d8a0ad','rojo':'#8d2f2f','red':'#8d2f2f','verde':'#5d6b55','green':'#5d6b55','crema':'#eee3d3','cream':'#eee3d3','nude':'#d8c2a8','camel':'#a67750','khaki':'#8d846c','caqui':'#8d846c','denim':'#3a5872'
  };
  function paintDots(scope){
    $$('[data-color-name]',scope).forEach(dot=>{
      const key=(dot.dataset.colorName||'').toLowerCase().trim();
      const found=Object.keys(colorMap).find(k=>key.includes(k));
      dot.style.background=found?colorMap[found]:'#D8C2A8';
    });
  }
  function initProduct(root){
    const variantsEl=root.querySelector('[data-product-variants]');
    const form=root.querySelector('[data-product-form]');
    if(!variantsEl||!form)return;
    let variants=[];
    try{variants=JSON.parse(variantsEl.textContent||'[]')}catch(e){variants=[]}
    const idInput=form.querySelector('[data-variant-id]');
    const price=root.querySelector('[data-product-price]');
    const compare=root.querySelector('[data-compare-price]');
    const add=root.querySelector('[data-add-to-cart]');
    const main=root.querySelector('[data-main-image]');
    const status=root.querySelector('[data-variant-status]');
    const summary=root.querySelector('[data-selection-summary]');
    const addText=(add&&add.dataset.addText)||'Añadir al carrito';
    paintDots(root);
    function productMoney(cents){
      return (Number(cents||0)/100).toLocaleString('es-ES',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'});
    }
    function groups(){return $$('[data-option-index]',root).sort((a,b)=>Number(a.dataset.optionIndex)-Number(b.dataset.optionIndex));}
    function selectedOptions(includeNull=false){
      return groups().map(group=>{
        const active=group.querySelector('.ad-pdp__option.is-active');
        return active?active.dataset.optionValue:(includeNull?null:undefined);
      }).filter(v=>includeNull||v!==undefined);
    }
    function variantMatches(v,selection,complete=false){
      if(!v.options)return false;
      if(complete&&v.options.length!==selection.length)return false;
      return v.options.every((option,i)=>selection[i]==null||selection[i]===option);
    }
    function optionExists(index,value){
      const selection=selectedOptions(true);
      selection[index]=value;
      return variants.some(v=>variantMatches(v,selection,false));
    }
    function optionCanShip(index,value){
      const selection=selectedOptions(true);
      selection[index]=value;
      return variants.some(v=>v.available&&variantMatches(v,selection,false));
    }
    function updateBundlePrices(priceCents){
      $$('[data-bundle-price]',root).forEach(el=>{
        const qty=Number(el.dataset.bundleQty||1);
        let total=Number(priceCents||0)*qty;
        if(qty===2)total*=.95;
        if(qty===3)total*=.92;
        el.textContent=productMoney(Math.round(total));
      });
    }
    function updateSummary(variant){
      if(!summary)return;
      const opts=variant&&variant.options?variant.options:selectedOptions(true).filter(Boolean);
      summary.textContent=opts.length?`Seleccionado: ${opts.join(' / ')}`:'Selecciona color y talla';
    }
    function setUnavailable(text='Combinación no disponible'){
      if(idInput)idInput.value='';
      if(add){add.disabled=true;add.textContent='No disponible';}
      if(status){status.textContent=text;status.classList.add('is-unavailable')}
      updateSummary(null);
    }
    function setVariant(variant){
      if(!variant){setUnavailable();updateAvailability();return;}
      if(idInput)idInput.value=variant.id;
      if(price)price.textContent=variant.price;
      if(compare)compare.textContent=variant.compare_at_price;
      updateBundlePrices(variant.price_cents);
      if(add){
        add.disabled=!variant.available;
        add.textContent=variant.available?addText:'Agotado';
      }
      if(status){
        status.textContent=variant.available?'Disponible · envío gratis siempre':'Agotado temporalmente';
        status.classList.toggle('is-unavailable',!variant.available);
      }
      updateSummary(variant);
      if(variant.image&&main){
        main.src=variant.image;
        main.removeAttribute('srcset');
      }
      updateAvailability();
      if(history.replaceState){
        const url=new URL(window.location.href);
        url.searchParams.set('variant',variant.id);
        history.replaceState({},'',url.toString());
      }
    }
    function updateAvailability(){
      groups().forEach(group=>{
        const index=Number(group.dataset.optionIndex||0);
        $$('.ad-pdp__option',group).forEach(btn=>{
          const exists=optionExists(index,btn.dataset.optionValue);
          const canShip=optionCanShip(index,btn.dataset.optionValue);
          btn.disabled=!exists;
          btn.classList.toggle('is-disabled',!exists);
          btn.classList.toggle('is-sold-out',exists&&!canShip);
          btn.setAttribute('aria-disabled',String(!exists));
          const label=btn.querySelector('.ad-pdp__option-note');
          if(label)label.remove();
          if(exists&&!canShip){
            const note=document.createElement('small');
            note.className='ad-pdp__option-note';
            note.textContent='Agotado';
            btn.appendChild(note);
          }
        });
      });
    }
    groups().forEach(group=>{
      group.addEventListener('click',e=>{
        const btn=e.target.closest('.ad-pdp__option');
        if(!btn||btn.disabled)return;
        $$('.ad-pdp__option',group).forEach(b=>{b.classList.remove('is-active');b.setAttribute('aria-pressed','false')});
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed','true');
        const current=root.querySelector(`[data-option-current="${group.dataset.optionIndex}"]`);
        if(current)current.textContent=btn.dataset.optionValue;
        const opts=selectedOptions(true);
        const match=variants.find(v=>variantMatches(v,opts,true));
        setVariant(match);
      });
    });
    $$('.ad-pdp__thumb',root).forEach(thumb=>thumb.addEventListener('click',()=>{
      $$('.ad-pdp__thumb',root).forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if(main&&thumb.dataset.pdpThumb){
        main.src=thumb.dataset.pdpThumb;
        main.alt=thumb.dataset.pdpThumbAlt||main.alt;
        main.removeAttribute('srcset');
      }
    }));
    const initial=variants.find(v=>String(v.id)===String(idInput&&idInput.value))||variants.find(v=>v.available)||variants[0];
    if(initial){
      groups().forEach((group,i)=>{
        const value=initial.options&&initial.options[i];
        if(!value)return;
        $$('.ad-pdp__option',group).forEach(b=>{
          const active=b.dataset.optionValue===value;
          b.classList.toggle('is-active',active);
          b.setAttribute('aria-pressed',String(active));
        });
        const current=root.querySelector(`[data-option-current="${group.dataset.optionIndex}"]`);
        if(current)current.textContent=value;
      });
      setVariant(initial);
    }else{
      updateAvailability();
      updateSummary(null);
    }
  }
  $$('[data-ad-product]').forEach(initProduct);
})();

;(()=>{
  document.querySelectorAll('[data-ad-sortby]').forEach(select=>{
    select.addEventListener('change',()=>{
      const url=new URL(window.location.href);
      url.searchParams.set('sort_by',select.value);
      url.searchParams.delete('page');
      window.location.href=url.toString();
    });
  });
})();

;(()=>{
  const languages={
    es:{code:'ES',flag:'🇪🇸'},
    en:{code:'EN',flag:'🇬🇧'},
    fr:{code:'FR',flag:'🇫🇷'},
    de:{code:'DE',flag:'🇩🇪'},
    it:{code:'IT',flag:'🇮🇹'},
    pt:{code:'PT',flag:'🇵🇹'}
  };
  const sourceLang='es';
  const cookieName='googtrans';
  const storageKey='ad_preferred_language';
  const setCookie=(name,value,days=365)=>{
    const expires=new Date(Date.now()+days*864e5).toUTCString();
    document.cookie=`${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    const host=location.hostname.replace(/^www\./,'');
    if(host.includes('.')) document.cookie=`${name}=${value}; expires=${expires}; path=/; domain=.${host}; SameSite=Lax`;
  };
  const getCookie=name=>document.cookie.split('; ').find(row=>row.startsWith(`${name}=`))?.split('=').slice(1).join('=')||'';
  const getStoredLang=()=>{
    try{return localStorage.getItem(storageKey)||'';}catch(e){return '';}
  };
  const storeLang=lang=>{
    try{localStorage.setItem(storageKey,lang);}catch(e){}
  };
  const activeLang=()=>{
    const stored=getStoredLang();
    if(languages[stored])return stored;
    const cookie=decodeURIComponent(getCookie(cookieName));
    const match=cookie.match(/\/[^/]+\/([a-z]{2})/i);
    return languages[match?.[1]]?match[1]:sourceLang;
  };
  const updateButtons=lang=>{
    const data=languages[lang]||languages[sourceLang];
    document.querySelectorAll('[data-ad-language-switcher]').forEach(switcher=>{
      const flag=switcher.querySelector('[data-ad-language-current-flag]');
      const code=switcher.querySelector('[data-ad-language-current-code]');
      if(flag)flag.textContent=data.flag;
      if(code)code.textContent=data.code;
      switcher.querySelectorAll('[data-ad-language-option]').forEach(option=>{
        const isActive=option.dataset.lang===lang;
        option.classList.toggle('is-active',isActive);
        option.setAttribute('aria-current',isActive?'true':'false');
      });
    });
  };
  const applyGoogleTranslate=lang=>{
    const value=`/${sourceLang}/${lang}`;
    setCookie(cookieName,value);
    storeLang(lang);
    updateButtons(lang);
    const combo=document.querySelector('.goog-te-combo');
    if(combo){
      combo.value=lang;
      combo.dispatchEvent(new Event('change'));
      setTimeout(()=>{if(lang===sourceLang)location.reload();},120);
    }else{
      setTimeout(()=>location.reload(),120);
    }
  };
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-ad-language-toggle]');
    const option=event.target.closest('[data-ad-language-option]');
    if(toggle){
      const switcher=toggle.closest('[data-ad-language-switcher]');
      const open=!switcher.classList.contains('is-open');
      document.querySelectorAll('[data-ad-language-switcher].is-open').forEach(el=>{
        el.classList.remove('is-open');
        el.querySelector('[data-ad-language-toggle]')?.setAttribute('aria-expanded','false');
      });
      switcher.classList.toggle('is-open',open);
      toggle.setAttribute('aria-expanded',String(open));
      return;
    }
    if(option){
      const lang=option.dataset.lang;
      document.querySelectorAll('[data-ad-language-switcher].is-open').forEach(el=>{
        el.classList.remove('is-open');
        el.querySelector('[data-ad-language-toggle]')?.setAttribute('aria-expanded','false');
      });
      if(languages[lang]) applyGoogleTranslate(lang);
      return;
    }
    if(!event.target.closest('[data-ad-language-switcher]')){
      document.querySelectorAll('[data-ad-language-switcher].is-open').forEach(el=>{
        el.classList.remove('is-open');
        el.querySelector('[data-ad-language-toggle]')?.setAttribute('aria-expanded','false');
      });
    }
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      document.querySelectorAll('[data-ad-language-switcher].is-open').forEach(el=>{
        el.classList.remove('is-open');
        el.querySelector('[data-ad-language-toggle]')?.setAttribute('aria-expanded','false');
      });
    }
  });
  updateButtons(activeLang());
})();

;(()=>{
  const overlays=['.mobile-menu','.search-overlay','.cart-drawer'];
  const syncLock=()=>{
    const isOpen=overlays.some(sel=>document.querySelector(sel)?.classList.contains('is-open'));
    document.body.classList.toggle('ad-mobile-lock',isOpen && window.matchMedia('(max-width: 720px)').matches);
  };
  const closeAll=()=>{
    overlays.forEach(sel=>document.querySelector(sel)?.classList.remove('is-open'));
    syncLock();
  };
  const mo=new MutationObserver(syncLock);
  overlays.forEach(sel=>{const el=document.querySelector(sel); if(el) mo.observe(el,{attributes:true,attributeFilter:['class']});});
  document.addEventListener('click',event=>{
    const mobileLink=event.target.closest('.mobile-menu__links a');
    if(mobileLink) setTimeout(closeAll,30);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeAll();});
  window.addEventListener('resize',syncLock,{passive:true});
  syncLock();
})();

;(()=>{
  const colorMap={
    'negro':'#111111','black':'#111111','blanco':'#f6f2ea','white':'#f6f2ea','marfil':'#f6f2ea','beige':'#d8c2a8','arena':'#d8c2a8','sand':'#d8c2a8','rafia':'#caa76d','natural':'#caa76d','marrón':'#8b5e3c','marron':'#8b5e3c','brown':'#8b5e3c','mocha':'#8b5e3c','cacao':'#8b5e3c','gris':'#8a8a8a','stone':'#8a8a8a','gray':'#8a8a8a','grey':'#8a8a8a','azul':'#2f4d68','cielo':'#8fb0c8','blue':'#2f4d68','carey':'#6c472e','champagne':'#eadbc8','clear':'#eadbc8'
  };
  const paintGlobalDots=()=>document.querySelectorAll('.product-card [data-color-name]').forEach(dot=>{
    const key=(dot.dataset.colorName||'').toLowerCase().trim();
    const found=Object.keys(colorMap).find(k=>key.includes(k));
    dot.style.background=found?colorMap[found]:'#D8C2A8';
  });
  paintGlobalDots();
  document.addEventListener('click',event=>{
    const btn=event.target.closest('[data-sticky-add]');
    if(!btn)return;
    const add=document.querySelector('[data-add-to-cart]');
    if(add){add.click();}
  });
  const mainPrice=document.querySelector('[data-product-price]');
  const stickyPrice=document.querySelector('[data-sticky-price]');
  if(mainPrice&&stickyPrice){
    stickyPrice.textContent=mainPrice.textContent;
    new MutationObserver(()=>{stickyPrice.textContent=mainPrice.textContent;}).observe(mainPrice,{childList:true,characterData:true,subtree:true});
  }
})();

;(()=>{
  const stickyBtn=document.querySelector('[data-sticky-add]');
  const add=document.querySelector('[data-add-to-cart]');
  if(!stickyBtn||!add)return;
  const sync=()=>{
    stickyBtn.disabled=!!add.disabled;
    stickyBtn.textContent=add.disabled?add.textContent:'Añadir al carrito';
  };
  sync();
  new MutationObserver(sync).observe(add,{attributes:true,childList:true,characterData:true,subtree:true});
})();
